export enum ApiCallState {
    Loading,
    Error,
    Success,
}

export enum NetworkState {
    Idle,
    Error,
    Success,
    Loading,
}
